import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import api from "../Api";
import TableFooter from "../components/TableFooter";
// import { Link } from "react-router-dom";
import Popup from "../components/PopUP";
import { useParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import MarkdownText from "../components/MarkdownText";
import {IMAGE_URL} from "../utils/constants";

export default function ReportMangement() {
  const { game } = useParams();
  const [reports, setReports] = useState([]);
  const [selectedGame, setSelectedGame] = useState(game || "");
  const [loading, setLoading] = useState(true);
  const [popupMessage, setPopupMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [pagination, setPagination] = useState({
    count: 0,
    total_pages: 0,
    next: 0,
    previous: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  const gamesList = [
    { id: 1, name: "Calculation", path: "calculation" },
    { id: 2, name: "One Word", path: "one-word" },
    { id: 3, name: "Quiz", path: "quiz" },
    { id: 4, name: "Blackbox", path: "blackbox" },
    { id: 5, name: "Citius. Altius. Longius.", path: "encyclopaedia"},
    { id: 6, name: "Plane Spotter", path: "image-game"},
    { id: 7, name: "Jetting Around The World", path: "trivia"},
  ];

  const getGameEndpoint = (gamePath) => {
    const gameMap = {
      calculation: "calculation",
      "one-word": "one-word",
      quiz: "quiz",
      blackbox: "blackbox",
      encyclopaedia: "encyclopaedia",
      "image-game": "image-game",
      trivia: "trivia"

    };
    return gameMap[gamePath] || gamePath;
  };

  useEffect(() => {
    if (loading === false) {
      setPopupMessage("Reports loaded successfully");
    }
  }, [loading]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const gameEndpoint = getGameEndpoint(selectedGame);
      const response = await api.get(
        `${gameEndpoint}/admin/report-question`,
        {
          params: {
            page: currentPage,
          },
        }
      );

      setReports(response.data.data || []);
      // Handle new pagination structure from API
      setPagination({
        count: response.data.pagination?.total || 0,
        total_pages: response.data.pagination?.total_pages || 1,
        next: response.data.pagination?.has_next ? response.data.pagination?.next_skip : null,
        previous: response.data.pagination?.has_previous ? response.data.pagination?.previous_skip : null,
      });
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setLoading(false);
    }
  }, [currentPage, selectedGame]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleViewDetails = async (report) => {
    setSelectedReport(report);
    setShowModal(true);
  };

  const handleApprove = async () => {
    try {
      const gameEndpoint = getGameEndpoint(selectedGame);
      await api.patch(
        `${gameEndpoint}/admin/resolve-report`, {
          id: selectedReport.id
        }
      );
      setPopupMessage("Report approved successfully");
      setShowModal(false);
      setSelectedReport(null);
      fetchData();
    } catch (error) {
      console.error("Error approving report:", error);
      setPopupMessage("Failed to approve report");
    }
  };

  const handleNavigate = async () => {
    const gameEndpoint = getGameEndpoint(selectedGame);
    console.log("Navigating to question set for game:", selectedGame);
    if(gameEndpoint === "encyclopaedia" || gameEndpoint === "image-game" || gameEndpoint === "trivia"){
       navigate(`/game-question-set/${selectedGame}/${selectedReport.set_id}`)
    }
    else if (gameEndpoint === "blackbox") {
      navigate(`/game-management/black-box-game/${selectedReport.game_name}/${selectedReport.set_id}#${selectedReport.payload.question_id}`);
    }
    else {
      navigate(`/game-management/${gameEndpoint}-game/${selectedReport.game_number}/${selectedReport.level}/${selectedReport.set_id}#${selectedReport.payload.question_id}`);
    }
  };

  return (
    <div className="user-management-page">
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      {/* Sidebar */}
      <Sidebar />

      {/* Main Wrapper */}
      <div className="main-wrapper">
        {/* Header */}
        <Header />

        {/* Content Section */}
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <h1>Report Management - {selectedGame && gamesList.find(g => g.path === selectedGame)?.name}</h1>
                      </div>
                    </div>
                  </div>

                  {/* Table */}
                  {loading ? (
                    <div style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "400px",
                      width: "100%"
                    }}>
                      <div style={{
                        textAlign: "center"
                      }}>
                        <img
                          src={IMAGE_URL+"loader.gif"}
                          alt="Loading..."
                          style={{
                            maxWidth: "100px",
                            marginBottom: "20px"
                          }}
                        />
                        <p style={{
                          fontSize: "16px",
                          color: "#666",
                          fontWeight: "500"
                        }}>Loading reports...</p>
                      </div>
                    </div>
                  ) : (
                    <div className="common-table-wrapper mt-4">
                      <div className="common-table-filter-wrapper">
                        <div className="common-left-blk">
                          <div className="common_sub_heading_wrapper mb-0">
                            <h2>Report Question Listing</h2>
                          </div>
                        </div>
                        {/* <div className="common-right-blk">
                          <div className="common-sort-blk">
                            <div className="common-search-blk">
                              <input
                                type="search"
                                className="form-control"
                                id="search"
                                value={query}
                                placeholder="Search"
                                onChange={(e) => setQuery(e.target.value)}
                              />
                            </div>
                          </div>
                          <button className="filter_action_btn cal_btn">Jun 18, 2025 - Jun 23, 2025</button>
                        </div> */}
                      </div>

                      <div className="table-blk table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>S.No.</th>
                              <th>User</th>
                              <th>Game Name</th>
                              <th>Reason</th>
                              <th>Reported At</th>
                              <th>Status</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {reports.length > 0 &&
                              reports.map((report, index) => (
                                <tr key={report.id}>
                                  <td>{(index + 1) + (currentPage - 1) * 10}</td>

                                  <td>
                                    {report.first_name ? <span className="text-capitalize">{report.first_name} {report.last_name}</span>: <>{report.email}</>}
                                  </td>
                                  <td className="text-capitalize">{report.game_name.replace("_", ' ')}</td>
                                  <td>
                                    {report.reason}
                                  </td>
                                  <td>
                                    {report.created_at}
                                  </td>
                                  <td>
                                    {report.is_resolved? <span className="badge bg-light text-success">Resolved</span> :
                                    <span className="badge bg-light text-warning">Pending</span>}
                                  </td>
                                  <td>
                                    <div className="form-check">
                                      <button
                                        className="btn btn-link p-0"
                                        onClick={() => handleViewDetails(report)}
                                        style={{ border: "none", background: "none" }}
                                      >
                                        <img src={IMAGE_URL+"eye-tbl-icon.svg"} alt="View" />
                                      </button>
                                    </div>
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {/* footer */}
                      <TableFooter
                        pagination={pagination}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  )}
                  {/* Delete Modal */}
                  {/* <DeactivateModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    onConfirm={handleConfirmDeactivation}
                    itemName={selectedItem ? selectedItem.name : ""}
                  /> */}
                  {/* <ActivateModal
                    show={showActiveModal}
                    onClose={() => setActiveShowModal(false)}
                    onConfirm={handleConfirmActivation}
                    itemName={selectedItem ? selectedItem.name : ""}
                  /> */}
                  {/*  */}

                  {/* Question Details Modal */}
                  {showModal && selectedReport && (
                    <div
                      className="modal fade show"
                      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                      tabIndex="-1"
                      role="dialog"
                    >
                      <div className="modal-dialog modal-xl" role="document" style={{ maxWidth: "900px" }}>
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Report Question Details</h5>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => {
                                setShowModal(false);
                                setSelectedReport(null);
                              }}
                            ></button>
                          </div>

                          <div className="modal-body" style={{ maxHeight: "80vh", overflowY: "auto", minHeight: "500px" }}>
                            {/* User Information */}
                            <div className="mb-4">
                              <h6 className="fw-bold mb-3">User Information</h6>
                              <div className="row g-3">
                                <div className="col-md-6">
                                  <small className="text-muted">Name</small>
                                  <p className="mb-0 text-capitalize">
                                    {selectedReport.first_name} {selectedReport.last_name}
                                  </p>
                                </div>
                                <div className="col-md-6">
                                  <small className="text-muted">Email</small>
                                  <p className="mb-0">{selectedReport.email}</p>
                                </div>
                              </div>
                            </div>

                            {/* Report Reason */}
                            <div className="mb-4">
                              <h6 className="fw-bold mb-2">Report Reason</h6>
                              <div
                                className="alert alert-warning mb-0"
                                role="alert"
                              >
                                <p className="mb-0">{selectedReport.reason}</p>
                              </div>
                            </div>

                            {/* Question Details */}
                            {selectedReport.payload && (
                              <>
                                <hr className="my-4" />
                                <h6 className="fw-bold mb-3">Question Details</h6>

                                {selectedReport.payload.title &&
                                 <div className="mb-3">
                                  <small className="text-muted d-block">Question Title</small>
                                  <p className="mb-2">{selectedReport.payload.title}</p>
                                </div>
                                }


                                <div className="mb-3">
                                  <small className="text-muted d-block">Question</small>
                                  <p className="mb-2">{selectedReport.payload.question}</p>
                                </div>

                                <div className="mb-3">
                                  <small className="text-muted d-block mb-2">Options</small>
                                  <div className="row g-2">
                                    {selectedReport.payload.options &&
                                      selectedReport.payload.options.map((option, index) => (
                                        <div className="col-12" key={index}>
                                          <div
                                            className="p-2 border rounded"
                                            style={{
                                              backgroundColor: "#f8f9fa",
                                              borderLeft:
                                                option.label ===
                                                selectedReport.payload.answer.split(",")[0]
                                                  ? "4px solid #28a745"
                                                  : "4px solid #dee2e6",
                                            }}
                                          >
                                            <small className="fw-bold">{option.label}:</small> <small>{option.value}</small>
                                            {option.label ===
                                              selectedReport.payload.answer.split(",")[0] && (
                                              <span className="badge bg-success ms-2">Correct</span>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                </div>

                                <div className="mb-3">
                                  <small className="text-muted d-block">Correct Answer</small>
                                  <p className="text-success fw-bold mb-2">{selectedReport.payload.answer}</p>
                                </div>

                                <div className="mb-3">
                                  <small className="text-muted d-block">Explanation</small>
                                  <div
                                    className="p-2 border rounded"
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    <MarkdownText className="small">
                                      {selectedReport.payload.explanation}
                                    </MarkdownText>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>

                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary"
                              onClick={() => {
                                setShowModal(false);
                                setSelectedReport(null);
                              }}
                            >
                              Close
                            </button>

                            <button
                              type="button"
                              className="btn btn-info text-white"
                              onClick={handleNavigate}
                            >
                              Show Set Details
                            </button>

                            {selectedReport.is_resolved ? "" : (
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={handleApprove}
                              >
                              Mark as Reviewed
                            </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
